import { AutogenLayoutCollectionsProfileFilter } from "./autogen/AutogenLayoutCollectionsProfileFilter";
import { CollectionsProfile } from "./CollectionsProfile";

export class CollectionsProfileFilter extends AutogenLayoutCollectionsProfileFilter {
    override onLoad() {
        const profileLayout = this.layoutProfile as CollectionsProfile;
        profileLayout.textboxDescr.enabled = false;
    }
}
